export default __webpack_public_path__ + "static/media/DreamJobs2_11.1e7e410e.png";